import React from 'react'
import { getPhilosophy } from './../../core/api/philosophy-provider'
import { Carousel, About } from './../../components'
import { Container, Row, Col } from 'react-bootstrap'


const Filosofia = () => {
    const [philosophyData, setPhilosophyData] = React.useState();

    React.useEffect(() => {
        getPhilosophy().then((response) => setPhilosophyData(response.data))
    },[])
    return (
        <>
            {
                philosophyData && (
                    <>
                        <Carousel slides={philosophyData.slides}/>
                        <Container fluid>
                            <Row>
                                <Col 
                                    md={{
                                        span: 10,
                                        offset: 1
                                    }}
                                    xs={12}
                                >
                                    {
                                        philosophyData?.about.map((about, index) => (
                                            <Row className='my-5'>
                                                <Col>
                                                    <About
                                                        key={index}
                                                        image_group={about.image_group}
                                                        content_group={about.content_group}
                                                        margin='5% 0px'
                                                        alignment={about.alignment}
                                                    />
                                                </Col>
                                            </Row>
                                        ))
                                    }
                                </Col>
                            </Row>
                        </Container>

                    </>
                )
            }

        </>
    )
}

export default Filosofia